<template>

  
  <button class="btn btn-after btn-animated"><slot></slot></button>


</template>

<script>
export default {
  name: "Bt9",
};
</script>

<style scoped>
@keyframes animateButton {
  0% {
    opacity: 0;
    transform: translateY(60px);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
}



.btn {
  position: relative;
  display: inline-block;
  outline: none;
  border: none;
  cursor: pointer;
  background-color: var(--light-cyan);
  font-size: 20px;
  font-weight: 500;
  border-radius: 10px;
  
  
 
  box-shadow: 0 6px var(--light-teal);
  transition: all 0.2s;
}
.btn:hover {
  transform: translateY(3px);
  box-shadow: 0 4px var(--light-teal);
}
.btn:active {
  transform: translateY(6px);
  box-shadow: none;
}
.btn:active::after {
  transform: scaleX(1.4) scaleY(1.6);
  opacity: 0;
}
.btn-after {
  background-color: var(--light-cyan);
}
.btn-after::after {
  background-color: var(--light-cyan);
}
.btn::after {
  content: "";
  position: absolute;
  display: inline-block;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  top: 0;
  left: 0;
  z-index: -1;
  transition: all 0.4s;
}
.btn-animated {
  animation: animateButton 0.5s ease-out 0.75s;
  animation-fill-mode: backwards;
}
</style>